export default "__VITE_ASSET__9ec829e2__"